import { Box, Grid, Modal, Button } from "@pankod/refine-mui";
import React, { useEffect, useState } from "react";

function ConfirmationModal({
  open,
  handleClose,
  handleConfirmation,
  data,
  confirmationType,
}) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: 800,
          minWidth: 320,
          background: "#fff",
          border: "unset",
          borderRadius: 4,
          p: 2,
        }}
      >
        <Grid container>
          <p>
            Vuoi addebitare {data}€ al cliente{" "}
            {confirmationType == "full"
              ? "per il pernotto effettuato"
              : "come penalità causa no-show"}
            ?
          </p>
        </Grid>
        <Grid container justifyContent="flex-start" mt={3} gap={3}>
          <Button
            variant="contained"
            color="success"
            size="large"
            sx={{ minWidth: 250 }}
            onClick={() => {
              handleConfirmation();
              handleClose();
            }}
          >
            CONFERMA
          </Button>

          <Button
            variant="contained"
            color="error"
            size="large"
            sx={{ minWidth: 250 }}
            onClick={handleClose}
          >
            ANNULLA
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
}

export default ConfirmationModal;
